<template>
  <div class="artifact-list-wrapper">
    <div
      v-if="relationStores.length"
      :style="{ transform: isShowArtifactList ? 'translate(-50%, 0)' : 'translate(-50%, calc(100% + 0.1rem))' }"
      class="artifact-list"
    >
      <div @click="hideArtifactList" class="header">
        <div class="back"></div>
        <div class="text">{{ headTitle }}</div>
      </div>
      <div class="list-container">
        <ul class="list">
          <li v-for="item in relationStores" :key="item.storeId" @click="clickArtifactItem(item)" class="list-item">
            {{ item.storeName }}
          </li>
        </ul>
      </div>
    </div>
    <div v-show="isShowArtifactList" class="_mask" @click="hideArtifactList"></div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    activityInfo: {
      default: null
    },
    storeInfo: {
      require: true,
      default: null
    },
    handleClickArtifactItem: {
      type: Function,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      isShowArtifactList: 'home/isShowArtifactList'
    }),
    relationStores () {
      return this.storeInfo?.redTemplate?.relationStores || []
    },
    headTitle () {
      return this.storeInfo?.redTemplate?.fnModule.relationCate?.text || '文物'
    }
  },
  methods: {
    ...mapMutations({
      setIsShowArtifactList: 'home/setIsShowArtifactList'
    }),
    hideArtifactList () {
      this.setIsShowArtifactList(false)
    },
    clickArtifactItem (item) {
      this.handleClickArtifactItem(item.storeId)
      this.hideArtifactList()
    }
  }
}
</script>

<style scoped="scoped" lang="scss">
.artifact-list-wrapper {
  .artifact-list {
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    width: 7.1rem;
    height: 5.66rem;
    box-shadow: 0 -0.04rem 0.08rem 0 rgba(113, 108, 98, 0.25);
    border-radius: 0.3rem 0.3rem 0 0;
    transition: all 0.5s;
    z-index: 3001;
    background: #f5f4f4;

    .header {
      position: relative;
      width: 7.1rem;
      height: 0.76rem;
      border-radius: 0.3rem 0.3rem 0 0;
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      justify-content: center;
      background: #fff;
      border-bottom: 1px solid #eee;
      .back {
        width: 0.34rem;
        height: 0.34rem;
        position: absolute;
        left: 0.2rem;
        top: 50%;
        transform: translateY(-50%);
        background: url(../../../../assets/images/icon_back.png) no-repeat center / 0.34rem;
      }
      .text {
        font-size: 0.28rem;
        color: #333333;
        letter-spacing: 0;
        text-align: center;
      }
    }

    .list-container {
      width: 7.1rem;
      position: relative;
      height: 4.89rem;
      background: #fff;
      overflow: scroll;

      .list {
        width: 7.1rem;
        display: flex;
        align-items: center;
        flex-flow: column nowrap;
        justify-content: flex-start;
        overflow: scroll;
        -webkit-overflow-scrolling: touch;

        .list-item {
          margin-top: 0.5rem;
          font-size: 0.32rem;
          text-align: center;
          color: #666666;
          width: 100%;
          min-height: auto;
          padding: 0 0.2rem;
        }
      }
    }
  }

  ._mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 3000;
    background: rgba(0, 0, 0, 0.5);
  }
}
</style>
